module.exports = __webpack_public_path__ + "img/mvp-gift-default.00eecc0c.png";